<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">微信订购</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">微信订购</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p>
                            <span style="font-size:18px;"><strong>一、关注夜樱情趣商城微信小程序</strong></span>
                        </p>
                        <p>
                            <strong>扫描下方二维码：</strong></p>
                        <p>
                            <img width="258" height="258" src="../../assets/image/minapp_qw.jpg">
                        </p>
                        <h3>
                            <span style="font-size:14px;">
                                <strong>&nbsp; &nbsp; &nbsp; &nbsp; 搜索微信小程序：
                                    <span style="font-size: 14px; color: rgb(192, 80, 77);">夜樱情趣</span>
                                </strong>
                            </span>
                        </h3>
                        <br>
                        <p><span class="font18">问题没解决？请拨打夜樱情趣商城官热线：联系在线客服</span></p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/dinggouliucheng" style="float:left;">上一篇:夜樱情趣商城订购流程</a>
                        <a href="/help/appdinggou" class="pl10" style="float:right">下一篇:APP订购</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font18{font-size: 18px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/weixindinggou.vue